import EmailInput from './Email.vue'
import PasswordInput from './Password.vue'
import CodeInput from './Code.vue'

export default {
    EmailInput,
    PasswordInput,
    CodeInput
}
